import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { Local } from 'protractor/built/driverProviders';
import { ApiMethod } from '../apimethods/api-method';
import { DataParam, customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { weightageuserwiseModel } from './weightage-userwisemodel';

declare var $;


@Component({
  selector: 'app-weightage-userwise',
  templateUrl: './weightage-userwise.component.html',
  styleUrls: ['./weightage-userwise.component.css']
})
export class weightageuserwiseComponent implements OnInit {

  modelItem = new weightageuserwiseModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  title: string;
  popupButtonText: string;
  showModal: boolean;
  RoleList: any;
  WeightageRoleLis: any;
  username: any;
    DepartmentsList: any;
    BUHeadList: any;

  ngOnInit() {


  }

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <weightageuserwiseModel>data["weightageuserwisePage"];


        $('#ddlRoleType').select2({
          placeholder: "Select Role",
          dropdownParent: "#btnPopupartDetails"
        });
        $('#ddlRoleType').val([]).trigger('change');

        $('#ddlWeightageRole').select2({
          placeholder: "Select Role",
          allowClear: true, tags: true,
          dropdownParent: "#btnAddPopupartDetails"
        });
        $('#ddlWeightageRole').val([]).trigger('change');

        $('#ddlBUHead').select2({
          placeholder: "Select BUHead",
          dropdownParent: "#btnTransferPopupartDetails"
        });
        $('#ddlBUHead').val([]).trigger('change');

        $('#ddlDepartment').select2({
          placeholder: "Select Department",
          dropdownParent: "#btnTransferPopupartDetails"
        });
        $('#ddlDepartment').val([]).trigger('change');

        

        this.GetRoleList();
        this.GetWeightageRoleList();
        this.GetAllBUHeadListAPI();

        this.GetweightageuserwiseData();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  //Get RoleList
  GetRoleList(): void {
    ApiMethod.getMethod(this.modelItem.RoleListAPI).subscribe(
      result => {
        this.RoleList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  GetWeightageRoleList(): void {
    ApiMethod.getMethod(this.modelItem.WeightageRoleListAPI + localStorage.aLoginID).subscribe(
      result => {
        this.WeightageRoleLis = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetAllBUHeadListAPI(): void {
    ApiMethod.getMethod(this.modelItem.GetAllBUHeadListAPI).subscribe(
      result => {
        const loginId = localStorage.getItem('aLoginID');
        console.log(loginId);
        // Filter out the BU Head with matching BUHeadID
        this.BUHeadList = result.aitemList.filter(item => item.BUHeadID != loginId);
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  DepartmentsListByBUHead(): void {
    
    if ($("#ddlBUHead").val() == null || $("#ddlBUHead").val() === '') {
      return;
    }
    var BUHead = $("#ddlBUHead").val().toString();
    ApiMethod.getMethod(this.modelItem.DepartmentsListByBUHeadAPI + BUHead).subscribe(
      result => {
        this.DepartmentsList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  GetweightageuserwiseData(): void {

    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "WeightageUserwiseConfig"
    }
    ApiMethod.postMethod(this.modelItem.weightageuserwiseListAPI, dataParam).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'WeightageUserwiseConfig';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Show Publisher details by ID
  showWeightageUserwise(): void {

    this.ClearData();

    if (localStorage.aEID && localStorage.aEID !== "0") {
      $("#btnPopupartDetails").show();
      this.popupButtonText = "Update";
      $("#LoadingImagePopup").show();

      ApiMethod.getMethod(this.modelItem.weightageuserwiseIDAPI + '/' + localStorage.aPubID + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();

          const aitems = result.aitemList;
          if (aitems && aitems.length > 0) {
            const data = aitems[0];

            // Set Role dropdown
            $("#ddlRoleType").val(data.RoleId).change();

            // Set Weightage performance fields
            $('#Txt_NonProduction').val(data.NonProduction);
            $('#Txt_ProductivityAchieved').val(data.ProductivtyAchieved);
            $('#Txt_Occupancy').val(data.Occupancy);
            $('#Txt_Punctuality').val(data.Punctuality);
            $('#Txt_Attendance').val(data.Attendance);
            $('#Txt_TotalSum').val(data.TotalSum);
            $('#Txt_DailyTargetPage').val(data.DailyTargetPages);

            // Optional fields - Uncomment if needed
            // $('#Txt_LD_Training').val(data.LD_Training);
            // $('#Txt_APQC_Skills').val(data.APQC_Skills);
            // $('#Txt_DeliverRCA_Skills').val(data.DeliverRCA_Skills);
            this.username = data.LoginName;
            this.title = `Update Weightage Userwise Config`;
          }
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed!", error.error.Message, "warning");
        }
      );
    } else {
      $("#btnAddPopupartDetails").show();
      this.username = '';
      this.title = "Add User";
      this.popupButtonText = "Add";
    }
  }

  calculateTotal(lastFieldId: string): void {
    const fields = [
      'Txt_NonProduction',
      'Txt_ProductivityAchieved',
      'Txt_Occupancy',
      'Txt_Punctuality',
      'Txt_Attendance',
      //'Txt_LD_Training',
      //'Txt_APQC_Skills',
      //'Txt_DeliverRCA_Skills'
    ];

    let total = 0;
    let allFieldsFilled = true;

    // First calculate total normally
    for (let fieldId of fields) {
      const input = document.getElementById(fieldId) as HTMLInputElement;
      if (input && input.value.trim() !== '') {
        const value = parseFloat(input.value);
        total += isNaN(value) ? 0 : value;
      } else {
        allFieldsFilled = false;
      }
    }

    const totalField = document.getElementById('Txt_TotalSum') as HTMLInputElement;
    const lastInput = document.getElementById(lastFieldId) as HTMLInputElement;

    // If there's an error
    if (total > 100 || (allFieldsFilled && total < 100)) {
      // Remove the last entered value
      if (lastInput) lastInput.value = '';

      // Recalculate total without the last field
      let newTotal = 0;
      for (let fieldId of fields) {
        if (fieldId === lastFieldId) continue;
        const input = document.getElementById(fieldId) as HTMLInputElement;
        if (input && input.value.trim() !== '') {
          const value = parseFloat(input.value);
          newTotal += isNaN(value) ? 0 : value;
        }
      }

      // Set the new total
      if (totalField) totalField.value = newTotal.toFixed(2);

      // Show warning
      ngswal("Warning !", total > 100 ? "Total cannot exceed 100!" : "Total must be exactly 100!", "warning");
      return;
    }

    // If no error, update total as normal
    if (totalField) {
      totalField.value = total.toFixed(2);
    }
  }

 

  //Update Weightage Rolewise details
  UpdateWeightageUserwise(): void {
    // Validate RoleType
    if ($('#ddlRoleType').val() == null) {
      ngswal("Warning !", "Select Role!", "warning");
      return;
    }

    // Validate NonProduction
    //if ($('#Txt_NonProduction').val() == '') {
    //  ngswal("Warning !", "Enter NonProduction value!", "warning");
    //  return;
    //}

    // Validate ProductivtyAchieved
    if ($('#Txt_DailyTargetPage').val() == '') {
      ngswal("Warning !", "Enter Daily Target Page  value!", "warning");
      return;
    }
    if ($('#Txt_ProductivityAchieved').val() == '') {
      ngswal("Warning !", "Enter Productivity Achieved value!", "warning");
      return;
    }
    
    // Validate Occupancy
    if ($('#Txt_Occupancy').val() == '' || $('#Txt_Occupancy').val() == 0) {
      ngswal("Warning !", "Enter Occupancy value!", "warning");
      return;
    }

    if ($('#Txt_Punctuality').val() == '' || $('#Txt_Punctuality').val() == 0) {
      ngswal("Warning !", "Enter Punctuality value!", "warning");
      return;
    }

    if ($('#Txt_Attendance').val() == '' || $('#Txt_Attendance').val() == 0) {
      ngswal("Warning !", "Enter Attendance value!", "warning");
      return;
    }

    //if ($('#Txt_LD_Training').val() == '' || $('#Txt_LD_Training').val() == 0) {
    //  ngswal("Warning !", "Enter LD Training value!", "warning");
    //  return;
    //}

    //if ($('#Txt_APQC_Skills').val() == '' || $('#Txt_APQC_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter APQC Skills value!", "warning");
    //  return;
    //}

    //if ($('#Txt_DeliverRCA_Skills').val() == '' || $('#Txt_DeliverRCA_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter Deliver RCA Skills value!", "warning");
    //  return;
    //}

    // If all validations pass, show the loading popup
    $("#LoadingImagePopup").show();

    // Gather all values from the UI and map to the Dataitem object
    var Dataitem = {
      Id: localStorage.aEID,
      RoleId: $("#ddlRoleType").val(),
      UserId: localStorage.aEID,
      PublisherId: 0,
      NonProduction: parseFloat($("#Txt_NonProduction").val() || '0'),
      ProductivtyAchieved: parseFloat($("#Txt_ProductivityAchieved").val() || '0'),
      Occupancy: parseFloat($("#Txt_Occupancy").val() || '0'),
      Punctuality: parseFloat($("#Txt_Punctuality").val() || '0'),
      Attendance: parseFloat($("#Txt_Attendance").val() || '0'),
      //LD_Training: parseFloat($("#Txt_LD_Training").val() || '0'),
      //APQC_Skills: parseFloat($("#Txt_APQC_Skills").val() || '0'),
      //DeliverRCA_Skills: parseFloat($("#Txt_DeliverRCA_Skills").val() || '0'),
      LD_Training: 0,
      APQC_Skills: 0,
      DeliverRCA_Skills: 0,
      TotalSum: parseFloat($("#Txt_TotalSum").val() || '0'),
      DailyTargetPages: $("#Txt_DailyTargetPage").val() || '0',
      BUHeadComment: ($("#Txt_CommentNote").val() || '').trim() !== '' ? $("#Txt_CommentNote").val().trim() : '',
      UpdatedBy: localStorage.aLoginID
    };
    ApiMethod.postMethod(this.modelItem.weightageuserwiseUpdateAPI, Dataitem).subscribe(
      response => {

        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hide();
          this.GetweightageuserwiseData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }

        $("#LoadingImagePopup").hide();

      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImagePopup").hide();
      }
    );
  }

  GetnewUserDetails() {
    const userid = $("#ddlUserType").val();
    // Do not proceed if UserType dropdown has value 0 or is empty
    if (localStorage.aEID == 0 && userid != "0" && userid !== null) {
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.NewUserRoledetailsAPI + '/' + userid).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;

          if (aitems && aitems.length > 0) {
            const data = aitems[0];
            // Set role dropdown
            $("#ddlRoleType").val(data.RoleId).trigger("change");

            // Set weightage fields
            $("#Txt_NonProduction").val(data.NonProduction);
            $("#Txt_ProductivityAchieved").val(data.ProductivtyAchieved);
            $("#Txt_Occupancy").val(data.Occupancy);
            $("#Txt_Punctuality").val(data.Punctuality);
            $("#Txt_Attendance").val(data.Attendance);
            //$("#Txt_LD_Training").val(data.LD_Training);
            //$("#Txt_APQC_Skills").val(data.APQC_Skills);
            //$("#Txt_DeliverRCA_Skills").val(data.DeliverRCA_Skills);
            $("#Txt_TotalSum").val(data.TotalSum);
          } else {
            ngswal("Failed !", "No user role details found.", "warning");
          }
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
    }
  }


  ClearData(): void {
    $("input[type='text']").val("");
    $("input[type='number']").val("");
    $("#Txt_CommentNote").val("")
    $("#ddlRoleType").val(0).change();
    $("#ddlWeightageRole").val(0).change();

  }
  hide(): void {
    $("#btnPopupartDetails").hide();
  }



  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return false;
    }
    return true;

  }
  NewUserUpdate(): void {
    if ($('#txtNewEmpID').val() == '') {
      ngswal("Warning !", "Enter New Emp ID !", "warning");
      return;
    }
    if ($('#txtFirstName').val() == '') {
      ngswal("Warning !", "Enter First Name !", "warning");
      return;
    }
    if ($('#txtLastName').val() == '') {
      ngswal("Warning !", "Enter Last Name !", "warning");
      return;
    }
    if ($('#txtLoginID').val() == '') {
      ngswal("Warning !", "Enter User Name !", "warning");
      return;
    }
    if ($('#txtEmail').val() == '') {
      ngswal("Warning !", "Enter Email !", "warning");
      return;
    }
    if ($('#ddlWeightageRole').val() == null) {
      ngswal("Warning !", "Select Role!", "warning");
      return;
    }
    if ($('#ddlActiveStatus').val() == null) {
      ngswal("Warning !", "Select Active Status!", "warning");
      return;
    }
    //if ($('#txtOldEmpID').val() == '') {
    //  ngswal("Warning !", "Enter Old Emp ID !", "warning");
    //  return;
    //}
    //if ($('#txtNewEmpID').val() == '') {
    //  ngswal("Warning !", "Enter New Emp ID !", "warning");
    //  return;
    //}
  

    $("#LoadingImagePopup1").show();

    var Dataitem = {
      FirstName: $('#txtFirstName').val(),
      LastName: $('#txtLastName').val(),
      LoginName: $('#txtLoginID').val(),
      LoginID: $('#txtLoginID').val(),
      RoleID: $('#ddlWeightageRole').val(),
      ActiveStatus: $('#ddlActiveStatus').val(),
      EmpId: $('#txtOldEmpID').val(),
      EmpId1: $('#txtNewEmpID').val(),
      EmailID: $('#txtEmail').val(),
      UpdatedBy: localStorage.aLoginID,
    };
    ApiMethod.postMethod(this.modelItem.WeightageAddUserAPI, Dataitem).subscribe(
      response => {

        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hideaddUserpopup();
          this.GetweightageuserwiseData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }

        $("#LoadingImagePopup1").hide();

      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImagePopup1").hide();
      }
    );
  }
  copyEmpIdToLoginId(): void {
    const newEmpID = $('#txtNewEmpID').val();
    $('#txtLoginID').val(newEmpID);
  }

  hideaddUserpopup(): void {
    $("#btnAddPopupartDetails").hide();
  }
/*--------------------------------------------------------------Transfer User Function-----------------------------------------------------*/
  TransferConfirmation() {
    var buHead = $('#ddlBUHead').val();
    var departmentId = $('#ddlDepartment').val();

    if (!buHead) {
      ngswal("Warning!", "Please select a BU Head!", "warning");
      return;
    }

    if (!departmentId) {
      ngswal("Warning!", "Please select a Department!", "warning");
      return;
    }
    ngswal({
      title: "Are you sure?",
      text: "Do you want to transfer this user to another department?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#1a56db',   // Blue for confirm
      cancelButtonColor: '#d33',       // Red for cancel
      confirmButtonText: 'Yes, Transfer',
      cancelButtonText: 'Cancel',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnTransferUser').trigger("click");  // Trigger transfer action
        } else {
          return false;
        }
      });
  }
  TransferUser() {
    var buHead = $('#ddlBUHead').val();
    var departmentId = $('#ddlDepartment').val();

    if (!buHead) {
      ngswal("Warning!", "Please select a BU Head!", "warning");
      return;
    }

    if (!departmentId) {
      ngswal("Warning!", "Please select a Department!", "warning");
      return;
    }

    $("#LoadingImageReopen").show();

    var dataParam = {
      LoginId: localStorage.getItem("aLoginID"),
      UserID: localStorage.getItem("aEID"),
      BuHead: buHead,
      DepartmentID: departmentId
    };

    ApiMethod.postMethod(this.modelItem.TransforUserAPI, dataParam).subscribe(
      response => {

        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hideTransferUserpopup();
          this.GetweightageuserwiseData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }
        $("#LoadingImageReopen").hide();

      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }
  ShowTransferPopup() {
    $("#ddlBUHead").val(0).change();
    $("#ddlDepartment").val(0).change();
    $("#btnTransferPopupartDetails").show();
  }
  hideTransferUserpopup() {
    $("#btnTransferPopupartDetails").hide();
  }
  /*--------------------------------------------------------------Resigned User Function-----------------------------------------------------*/
  ResignedUser() {

    var rejectDate = $('#Txt_RejectDate').val();

    if (!rejectDate) {
      ngswal("Warning!", "Please choose a reject date!", "warning");
      return;
    }
    $("#LoadingImagePopup2").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      UserID: localStorage.aEID,
      RejectUserDate: rejectDate
    }
    ApiMethod.postMethod(this.modelItem.RejectUserUpdateAPI, dataParam).subscribe(
      response => {
        
        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hideRejectUserpopup();
          this.GetweightageuserwiseData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }
        $("#LoadingImagePopup2").hide();
      }, error => {
        $("#LoadingImagePopup2").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }
  ShowRejectPopup() {
    $("#btnRejectPopupartDetails").show();
  }
  hideRejectUserpopup() {
    $("#btnRejectPopupartDetails").hide();
  }
  RejectConfirmation() {
    var rejectDate = $('#Txt_RejectDate').val();

    if (!rejectDate) {
      ngswal("Warning!", "Please choose a reject date!", "warning");
      return;
    }
    ngswal({
      title: "Are you sure you want to reject this user?",
      text: "Once rejected, the user will be marked as inactive.",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, Reject',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnRejectUser').trigger("click"); // Replace with your actual reject action button ID
        } else {
          return false;
        }
      });
  }
}

